import { render } from "./alunoTermoAdesaoForm.vue?vue&type=template&id=0fe96822"
import script from "./alunoTermoAdesaoForm.vue?vue&type=script&lang=js"
export * from "./alunoTermoAdesaoForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__